import useNestedRelationData from './useNestedRelationData'
import NestedRelationCardView from './NestedRelationCardView'
import { NestedRelationCardProps } from './NestedRelationCard.types'
import useTableLayouts from 'site/Renderer/components/DataTables/hooks/useTableLayouts'
import useColumns from 'site/Renderer/components/DataTables/hooks/useColumns'
import useObjectclass from 'objectclass/shared/hooks/useObjectclass'
import { updateDisplayText } from 'shared/utils/fields/fields'
import { useMemo } from 'react'

const NestedRelationCard = ({
  layoutClassificationUuid,
  fieldSettings,
  sourcesConfig,
  objectclassUuid,
  object,
  id,
  title,
  navigationSliderBackgroundColor,
  navigationSliderColor
}: NestedRelationCardProps) => {
  const {
    tableLayouts: [tableLayout],
    isLoading: isLoadingTableLayout
  } = useTableLayouts({ layoutClassificationUuid })

  const { allColumns: columns } = useColumns({
    tableLayout
  })

  const { objectclass } = useObjectclass({ objectclassUuid })

  const { fields = {} } = objectclass || {}

  const updatedFields = useMemo(
    () => updateDisplayText(fields, fieldSettings),
    [fieldSettings, fields]
  )

  const enabledNestedRelationData =
    !!objectclass && !isLoadingTableLayout && !!object

  const { data = [], isLoading } = useNestedRelationData({
    columns,
    sourcesConfig,
    fields: updatedFields,
    object,
    enabled: enabledNestedRelationData
  })

  return (
    <NestedRelationCardView
      isLoading={isLoading}
      data={data}
      id={id}
      title={title}
      navigationSliderBackgroundColor={navigationSliderBackgroundColor}
      navigationSliderColor={navigationSliderColor}
    />
  )
}

export default NestedRelationCard
